import { MeetingRoomCreateRequest } from "../../model/meetingRoomCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = MeetingRoomCreateRequest;

export async function postMeetingRooms(payload: DtoType) {
  try {
    const url = apiUrls.postMeetingRooms;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postMeetingRooms:", err);
  }
}
